module.exports = __webpack_public_path__ + "img/invest_block4.53e69a20.png";